import { of } from "rxjs"

export class StubApiHelper {
    constructor() {}

    auth(hash) { }

    loginImpersonation(username: string) { }

    login(username: string, password: string, ignoreMaintenance: boolean) { }

    redirectImpersonated() { }

    redirectLogin(response, option) { }

    goToForbidden() { }

    isAppMaintenance() { }

    logUser(response, pass = null) { }

    getWithoutAuth(url: string, data = null, header: any) { }

    getWithoutResponse(url: string, data = null, header = null, responseType = null) { }

    get(url: string, data = null, header: any = {}) { }

    delete(url: string, header = {}) { }

    post() { }

    put(url: string, data: any, header = {}) { }

    patch(url: string, data: any, header = { }) { }

    handleError(error: Response | any) { }

    setHeaders(data) { }

    signUp(data) { }

    getCacheBustingQueryString() { }

    userObserver = of({
        tk: 'token',
        user: 'user'
    })
}
